export const TYPE_NUMBER = "number";
export const TYPE_RANGE = "range";

export const numberTypes = [
    { 
        value: TYPE_NUMBER,
        label: "Число"
    },
    {
        value: TYPE_RANGE,
        label: "Диапазон"
    }
];
